import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Button } from 'react-bootstrap';

interface DeleteButtonComponentProps{
    onClick: () => void;
    title?: string;
    isDisabled?: boolean;
}

const DeleteButtonComponent:React.FC<DeleteButtonComponentProps> = ({onClick, title, isDisabled}) => {
  return (
   <>
   <Button variant='light' onClick={onClick} title={title} disabled={isDisabled}>
    <FontAwesomeIcon icon={faTrash} color='#F24E1E'/>
   </Button>
   </>
  )
}

export default DeleteButtonComponent;